module.exports = __webpack_public_path__ + "static/media/club.825a856f.svg";